import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa"
import { motion } from "framer-motion";


const Body = styled.div`
  min-width: 250px;
  max-width: 250px;
  transition: all;
  height: ${props => "calc(100vh - 170px)"};
  /* margin-top: 26px; */
  border-radius: 16px;
  background-color: ${props => props.theme.cardBg};
  position: fixed;
  top: ${"155px"};
  z-index: 99;
  overflow-y: auto;
  padding: 16px;
  transition: all ease-in-out;
  transition-delay: 50ms;
  transition-duration: 700ms;
  ::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
`

const RespBody = styled(motion.div)`
  width: 320px;
  z-index: 9999;
  height: auto;
  border-radius: 16px ;
  background-color: ${(props) => props.theme.primaryBg};
  box-shadow:  0 1px 8px 0 rgba(0, 0, 0, 0.11);
  position: fixed;
  overflow: hidden;
  top: 65px;
  left: 9.5rem; // Center horizontally
`;



const LinkWrapper = styled.div`
  margin: 4px 0 0 0;
  z-index: 10;
  overflow-y: auto;
  scrollbar-width: none;
  position: relative;
`;

const MLink = styled.div`
  width: 100%;
  margin: 6px auto;
  padding: 2px 4px;
  /* background-color: #c33; */
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;
  position: relative;
  font-size: 0.8rem;
  border-radius: 10px;
   ${(props) => {
    return !props.active && css`
      &:hover {
        background-color: ${(props) => props.theme.hover};
      }
    `
  }}  

  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const NavItemWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
`;

const NavText = styled.div`
  margin: 0 4px;
  font-weight: ${props => props.isBold ? '700' : '500'};
  font-size: 16px;
`;

export const GroupDivider = styled.div`
  height: 1px;
  background-color: #5C5C5C;
  margin: 12px 0;
`

const SupportCardWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0 24px;
  padding-bottom: 20px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    transform: translateY(-3px);
  }
`;

const ExitText = styled.div`
  color: ${(props) => props.theme.exitRed};
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 8px;
  /* letter-spacing: 1.5px; */

  @media screen and (max-width: 480px){
    font-size: 1rem;
  }
`;

const ExitIcon = styled(FaSignOutAlt)`
    width: 20px;
    height: 20px;
    color: ${props => props.theme.exitRed};

    @media screen and (max-width: 480px){
      width: 18px;
      height: 18px;
    }
`

const SubLink = styled.div`
  cursor: pointer;
  width: 100%;
  padding: 12px;
  margin-top: -8px;
  transition: all 0.3s;
  position: relative;
  font-size: 0.8rem;
  color: ${props => props.active && props.theme.mainOrange || props.theme.color};
  background-color: ${(props) => props.theme.hover};

  @media screen and (max-width: 480px){
    font-size: 0.7rem;
  }

`

const SubLinkContainer = styled.div`
  margin: 0 30px;
  display: flex;
  align-items: center;
`

const MenuIconWrapper = styled.div`
    padding: 0.6rem;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  
  &:hover {
    /* background-color: ${(props) => props.theme.colorHeaderIconHover}; */
    opacity: 70%;
  };
  
  @media screen and (max-width: 768px) {
    padding: 0.5rem;
  };
`

export {
  Body,
  LinkWrapper,
  MLink,
  NavItemWrapper,
  NavText,
  SupportCardWrapper,
  ExitText,
  ExitIcon,
  SubLink,
  SubLinkContainer,
  RespBody,
  MenuIconWrapper
};
